module.exports = __webpack_public_path__ + "img/vacuum_3.77aebc1f.jpg";